module.exports = __webpack_public_path__ + "static/gorantla-478e9496a4c033c6a7dfd047561cb802.jpg";